let contractDetails = () => import('../app/Components/Views/Contracts/ContractCoordinator.vue'); // <- ruta donde estan los tabs

export default [
    {
        path: '/contracts/list/contract_details/summary',
        component: contractDetails,    
        name: 'contract-detail'
    },
    {
        path: '/contracts/list/contract_details/status',
        component: contractDetails,    
        name: 'contract-status'
    },
]